import React, { useState } from "react";
import "./timeline.css";
import { useTranslation } from "react-i18next";

const Timeline = () => {
  const { t } = useTranslation();

  const [index, setIndex] = useState(0);
  const [direction, setDirection] = useState("next");

  // All 9 items
  const items = Array.from({ length: 9 }, (_, i) => ({
    title: t(`vh-${i + 1}`),
    desc: t(`vd-${i + 1}`),
    align: i % 2 === 0 ? "left" : "right",
  }));

  const next = () => {
    setDirection("next");
    setIndex((prev) => (prev + 1) % items.length);
  };

  const prev = () => {
    setDirection("prev");
    setIndex((prev) => (prev - 1 + items.length) % items.length);
  };

  return (
    <div className="timeline-wrapper-" style={{width:'100%'}}>
      {/* <div className="timeline-line"></div> */}

      <div className={`timeline-item `}>
       
        <div key={index} className={`timeline-box animate ${direction}`}>
        <p style={{background:'maroon',fontSize:'15pt',color:'orange'}}>{t("Important Vazhipads")}</p>
          <img
            src="./images/booking.png"
            alt="Booking"
            className="card-image"
          />

          <h4 style={{fontSize:'20pt',fontWeight:'600',color:'orange'}}>{items[index].title}</h4>
          <p style={{fontSize:'12pt',lineHeight:'20pt',color:'white'}}>{items[index].desc}</p>
        </div>
      </div>

      <div className="controls">
        <button onClick={prev}>⬅ Prev</button>
        <button onClick={next}>Next ➡</button>
      </div>
    </div>
  );
};

export default Timeline;